const replaceNull = (someObj, replaceValue = '') => {
  const replacer = (_, value) => 
    String(value) === 'null' || String(value) === 'undefined' ? replaceValue : value;
  return JSON.parse( JSON.stringify(someObj, replacer));
}
export default replaceNull